// Eligibility for the supervisor "Regresar a Picking" action (undo-in-review).
//
// Deliberately independent of the tarja: undoing the review is the NON-destructive way out, so it
// must not sit behind the per-store partial-fulfillment flag. Gating it there is what left stores
// without that flag holding orders they could neither send partially nor hand back.
//
// Mirrors PickingOrdersController#undo_in_review: the order must be parked, must not be flagged as
// a mandatory tarja (the backend rejects those with :requires_partial_fulfillment), and must still
// be on the picking path.
export const UNDO_IN_REVIEW_STATUSES = ['processing', 'picking']

// Both reassign paths refuse an order under review — the legacy one always has, and
// assign-tasks-bulk now answers 422 order_in_review. Disable the button rather than let the
// supervisor discover it after the click.
export const isOrderInReview = (order) => Boolean(order?.picking_order?.in_review)

export const canUndoInReview = (order, { hasReviewPermission } = {}) => {
    if (!order || !hasReviewPermission) return false

    const pickingOrder = order.picking_order
    if (!pickingOrder || !pickingOrder.in_review) return false
    if (pickingOrder.requires_partial_fulfillment) return false

    return UNDO_IN_REVIEW_STATUSES.includes(order.status)
}

// Refusals the supervisor can act on without leaving the undo dialog: the picker choice is wrong,
// and the dialog is where a different one gets picked. Every other code is terminal for that order.
export const RECOVERABLE_UNDO_ERRORS = [
    'picker_required',
    'picker_not_found',
    'picker_not_in_warehouse',
    'picker_cannot_pick',
]
